import React from "react";
import { CheckCheck, Bot } from "lucide-react";

/**
 * WhatsApp-style phone conversation mock showing conversational automation
 * with bot messages and interactive quick-reply buttons. Demo content only.
 */
export const WhatsAppChatMock = () => {
  return (
    <div className="relative mx-auto w-full max-w-[320px]">
      <div className="absolute -inset-4 rounded-[2.5rem] bg-[radial-gradient(circle_at_50%_20%,rgba(37,211,102,0.14),transparent_60%)] blur-xl" />
      <div className="relative rounded-[2rem] border-[6px] border-slate-900 bg-slate-900 shadow-[0_24px_80px_rgba(2,6,23,0.28)]">
        {/* Header */}
        <div className="flex items-center gap-2.5 rounded-t-[1.5rem] bg-[#075E54] px-4 py-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-white"><Bot className="h-4 w-4" /></span>
          <div className="leading-tight">
            <div className="text-[13px] font-semibold text-white">E Telecom Assistant</div>
            <div className="text-[10px] text-green-200">online · typically replies instantly</div>
          </div>
        </div>
        {/* Body */}
        <div className="space-y-2 bg-[#ECE5DD] px-3 py-4 min-h-[360px]">
          <Bubble side="out">Hi! 👋 Welcome to E Telecom. How can we help you today?</Bubble>
          <div className="flex flex-col items-end gap-1.5">
            <Chip>🛍️ Product Enquiry</Chip>
            <Chip>📄 Get Pricing</Chip>
            <Chip>🛠️ Support</Chip>
          </div>
          <Bubble side="in">Get Pricing</Bubble>
          <Bubble side="out">Great! Which solution are you interested in?</Bubble>
          <div className="flex flex-col items-end gap-1.5">
            <Chip>WhatsApp Automation</Chip>
            <Chip>Bulk SMS</Chip>
          </div>
          <Bubble side="out">Perfect — connecting you with a specialist now 🚀</Bubble>
        </div>
        {/* Input */}
        <div className="flex items-center gap-2 rounded-b-[1.5rem] bg-[#ECE5DD] px-3 pb-3">
          <div className="flex-1 rounded-full bg-white px-3 py-2 text-[11px] text-slate-400">Type a message</div>
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#25D366] text-white text-sm">➤</span>
        </div>
      </div>
    </div>
  );
};

const Bubble = ({ side, children }) => (
  <div className={`flex ${side === "out" ? "justify-start" : "justify-end"}`}>
    <div className={`max-w-[82%] rounded-2xl px-3 py-2 text-[11.5px] leading-snug shadow-sm ${side === "out" ? "rounded-tl-sm bg-white text-slate-700" : "rounded-tr-sm bg-[#DCF8C6] text-slate-800"}`}>
      {children}
      {side === "in" && <span className="ml-1 inline-flex align-middle"><CheckCheck className="h-3 w-3 text-blue-500" /></span>}
    </div>
  </div>
);

const Chip = ({ children }) => (
  <span className="rounded-lg border border-[#25D366]/40 bg-white px-3 py-1.5 text-[11px] font-medium text-[#075E54] shadow-sm">{children}</span>
);
